export const extractCognitoGroups = (userData: any, accessToken?: string): string[] => {
  const groups = userData?.['cognito:groups'] ?? userData?.userData?.['cognito:groups'];
  if (Array.isArray(groups)) {
    return groups;
  }
  if (typeof groups === 'string') {
    return [groups];
  }

  if (accessToken) {
    try {
      const payload = JSON.parse(atob(accessToken.split('.')[1]));
      const tokenGroups = payload?.['cognito:groups'];
      if (Array.isArray(tokenGroups)) {
        return tokenGroups;
      }
      if (typeof tokenGroups === 'string') {
        return [tokenGroups];
      }
    } catch {
      // Ignore malformed access token
    }
  }

  return [];
};
